import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthStatesEnum } from '@mlc/types';

@Component({
    selector: 'app-login-wrapper',
    templateUrl: './login-wrapper.component.html',
    styleUrls: ['./login-wrapper.component.scss'],
    standalone: false
})
export class LoginWrapperComponent implements OnInit {
  public state: AuthStatesEnum = AuthStatesEnum.AUTH;
  protected readonly AuthStatesEnum = AuthStatesEnum;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: { state?: AuthStatesEnum }) => {
      if (params.state) {
        this.state = params.state;
      }
    });
  }
}
